<template>
  <card
      @on-self-click="$emit('click', $event)"
      class="flex-col header-card"
      :class="{
        'wide-content': wideContent,
        'clickable': clickable,
        'underline': active,
        'nested': nested,
      }"
      :data-dusk="dataDusk"
      v-bind="$attrs"
      :wide-content="wideContent"
  >
    <template v-slot:header>
      <div
          @click="onHeaderRowClick($event)"
          class="flex-row gap-xs align-items-center justify-content-between "
          :class="{
            'pb-md': collapsedData && wideContent,
            'mb-md': !collapsedData,
            'pt-md container-h-lg': wideContent,
          }"
      >
        <div class="flex-row justify-content-between align-items-center" :style="{width: '100%' } ">
          <div class="flex-row flex-wrap gap-xs align-items-center">
            <div v-if="hasIcon" class="fill-primary">
              <slot name="icon">
                <i v-if="icon" class="fallback-icon fill-primary" :class="icon"></i>
              </slot>
            </div>
            <h2 class="header mb-0">{{ header }}</h2>
            <slot name="subtitle"></slot>
          </div>
          <div data-dusk="action" @click.stop>
            <slot name="action"><!-- accepts: dd-button or dd-rounded-button --></slot>
          </div>
        </div>
        <button class="btn-transparent header-card-toggle" v-if="collapsible" @click.stop="onDirectCollapseClick"
                :class="{ 'collapsed': collapsedData}">
          <ChevronDownIcon class="icon-size-lg fill-primary"></ChevronDownIcon>
        </button>
      </div>
      </template>
      <dd-collapse-transition
          v-if="collapsible"
          :collapsed="collapsedData"
          :duration="duration"
          :easing="easing"
          class="cursor-auto"
      >
        <slot></slot>
      </dd-collapse-transition>
      <template v-else>
        <div :style="{ cursor: 'auto'}" >
          <slot></slot>
        </div>
      </template>
    </card>
</template>

<script>
import Card from './Card.vue';
import _ from 'lodash'
export default {
  name: "HeaderCard",
  emits: ['collapse', 'click'],
  components: {Card},
  props: {
    wideContent: {
      default: false,
      required: false,
      type: Boolean,
    },
    header: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    duration: {
      type: Number,
      required: false,
      default: 200,
    },
    easing: {
      type: String,
      required: false,
      default: 'ease-in-out',
    },
    dataDusk: {
      type: String,
      required: false,
      default: () => _.uniqueId('header-card-'),
    },
    nested: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      collapsedData: this.collapsed,
    }
  },
  methods: {
    onHeaderRowClick(event) {
      if(this.clickable) {
        this.$emit('click', event);
      }
      else if (!this.clickable && this.collapsible) {
        this.toggleCollapse();
      }
    },
    onDirectCollapseClick() {
      this.toggleCollapse();
    },
    toggleCollapse() {
      if(!this.collapsible) return;
      this.collapsedData = !this.collapsedData;
      this.$emit('collapse', this.collapsedData);
    }
  },
  computed: {
    clickable() {
      return this.$listeners && this.$listeners.click;
    },
    hasIcon() {
      return "icon" in this.$slots || this.icon;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.cursor-auto {
  cursor: auto;
}
.content-wrapper {
  transition: all .2s ease-in-out;
}
.header-card-toggle {
  transition: all 0.2s ease-in-out;
  &.collapsed {
    transform: rotate(180deg);
  }
}
.header-card.nested {
  background-color: $main-content-bg-color !important;
  border-radius: $border-radius-large;
}

.header-card.underline {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    border: 3px solid $brand-primary;
  }
}
.header-card.clickable {
  transition: all .1s ease-in-out;
  cursor: pointer;
  &:hover {
    transform: translateY(-2px);
    box-shadow: $shadow-lg;
  }
  .header:hover {
    text-decoration: solid underline $brand-primary 1px;
  }
}
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $spacing-xxs;
  color: $blue !important;

  .header {
    margin: 0;
    font-size: $font-size-large;
  }
}
button.collapsed {
  i {
    transform: rotate(180deg);
  }
}
</style>
